module.exports = __webpack_public_path__ + "img/1498956610.05503e2a.jpg";